import { Button, Card, Col, Form, Input, Row, Image } from "antd";
import React, { useState } from "react";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";

const PushNotifications = () => {
  const [loading, setLoading] = useState(false);
  const [notificationImgUrl, setNotificationImgUrl] = useState<string>();

  const [form] = Form.useForm();

  const onSubmit = async (data) => {
    setLoading(true);

    const readyData = data && {
      title: data.title,
      token: `Bearer ${authenticateToken()}`,
      message: data.message,
      image: data.image,
      // topic: data.topic,
      // type: data.type,
      // typeId: data.typeId,
    };

    await fetch(
      `${process.env.REACT_APP_NOTIFICATION_API}/notification/topic`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("Notification Sent Successfully", "success");
          form.resetFields();
          setNotificationImgUrl(undefined);
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const resetData = () => {
    form?.resetFields();
  };

  return (
    <React.Fragment>
      <div
        className="product-table"
        style={{ overflowY: "auto", height: "calc(100vh - 150px)" }}
      >
        <Row
          gutter={25}
          align="middle"
          justify="center"
          className="product-table"
        >
          <Col span={12}>
            <Card title="Send Notification">
              <Form layout="vertical" onFinish={onSubmit} form={form}>
                <Form.Item
                  hasFeedback
                  label="Title"
                  name="title"
                  rules={[
                    {
                      required: true,
                      message: "Title is required",
                    },
                  ]}
                >
                  <Input
                    id="title"
                    type="text"
                    placeholder="Notification Title"
                  />
                </Form.Item>
                {/* <Form.Item
                  hasFeedback
                  label="Topic"
                  name="topic"
                  rules={[
                    {
                      required: true,
                      message: "Topic is required",
                    },
                  ]}
                >
                  <Input
                    id="topic"
                    type="text"
                    placeholder="Notification Topic"
                  />
                </Form.Item> */}
                <Form.Item
                  hasFeedback
                  label="Message"
                  name="message"
                  rules={[
                    {
                      required: true,
                      message: "Message is required",
                    },
                  ]}
                >
                  <Input.TextArea
                    rows={5}
                    id="message"
                    placeholder="Notification Message"
                  />
                </Form.Item>
                <Form.Item
                  name="image"
                  label="Image Url"
                  style={{ minWidth: "100%" }}
                  validateTrigger={["onChange", "onBlur"]}
                >
                  <Input
                    id="image"
                    placeholder="Enter Image Url"
                    onChange={async (e) => {
                      setNotificationImgUrl(e.target.value);
                    }}
                  />
                </Form.Item>

                {notificationImgUrl && (
                  <div className="mb-4">
                    <Image
                      src={notificationImgUrl}
                      style={{ maxHeight: "100px" }}
                    />
                  </div>
                )}

                <div className="buttons-container">
                  <Button
                    disabled={loading}
                    loading={(loading ? "loading" : undefined) as any}
                    type="primary"
                    htmlType="submit"
                    className="add-submit-btn text-center mr-2"
                  >
                    Submit
                  </Button>
                  <Button
                    type="ghost"
                    htmlType="button"
                    onClick={resetData}
                    className="reset-submit-btn text-center mr-2"
                  >
                    Reset
                  </Button>
                </div>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default PushNotifications;
